import { render } from "./TblColumnasDesgloseAbonosFactura.vue?vue&type=template&id=12a4de81"
import script from "./TblColumnasDesgloseAbonosFactura.vue?vue&type=script&lang=js"
export * from "./TblColumnasDesgloseAbonosFactura.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__